import { render, staticRenderFns } from "./goodsDatail.vue?vue&type=template&id=1d7f9e43&scoped=true&"
import script from "./goodsDatail.vue?vue&type=script&lang=js&"
export * from "./goodsDatail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDatail.vue?vue&type=style&index=0&id=1d7f9e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f9e43",
  null
  
)

export default component.exports